export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  areaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  cnpj: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/insurance/insurance-form.js